import { Input, TextArea, YesNoButton } from '../../../../components';
import { FormFields, FormHeader, FormSection } from '../form';
import { useValidation } from '../../../../hooks';
import { useFormContext } from 'react-hook-form';
import { claimFields } from '../../../../config';

import type { Dispatch, FC, SetStateAction } from 'react';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

interface IDamagerKnownProps {
  setSaveAndQuitChanges?: Dispatch<SetStateAction<Array<string>>>;
}

export const DamagerKnown: FC<IDamagerKnownProps> = ({ setSaveAndQuitChanges }) => {
  const formContext = useFormContext();
  const { fieldRequirements } = useValidation({});
  const { selectedLanguage } = useContext(LanguageSelectorContext);
  const localization = new Localization(selectedLanguage);

  const isDamagerKnown: boolean | null = formContext.watch(claimFields.whoWasDamager);
  const isDamagerDetailsKnown: boolean | null = formContext.watch(claimFields.haveDamagerContactDetails);

  const onIsDamagerKnownNoClick = () => {
    setSaveAndQuitChanges?.((prev) => [
      ...prev,
      'DamagerContactName',
      'DamagerEmail',
      'DamagerIdentificationComments',
      'DamagerName',
      'DamagerPhone',
      'DamagerStatement',
      claimFields.whoWasDamager,
      claimFields.haveDamagerContactDetails,
    ]);
    formContext?.setValue(claimFields.damagerIdentified, '');
    formContext?.setValue(claimFields.damagerName, '');
    formContext?.setValue(claimFields.haveDamagerContactDetails, false);
    formContext?.clearErrors(claimFields.damagerIdentified);
    formContext?.clearErrors(claimFields.damagerName);
    formContext?.clearErrors(claimFields.whoWasDamager);
  };

  const onIsDamagerKnownYesClick = () => {
    setSaveAndQuitChanges?.((prev) => [...prev, claimFields.whoWasDamager, claimFields.haveDamagerContactDetails]);
    formContext?.clearErrors(claimFields.whoWasDamager);
    formContext?.setValue(claimFields.haveDamagerContactDetails, null);
  };

  return (
    <FormSection>
      <FormHeader>{localization.translate('damagerKnown.header')}</FormHeader>
      <FormFields>
        {/* Is Damager Known? */}
        <YesNoButton
          isRequired
          isSelected={isDamagerKnown}
          labelText={localization.translate('damagerKnown.isDamagerKnownLabel')}
          name={claimFields.whoWasDamager}
          onNoClick={onIsDamagerKnownNoClick}
          onYesClick={onIsDamagerKnownYesClick}
          tooltip={localization.translate('damagerKnown.isDamagerKnownTooltip')}
        />

        {isDamagerKnown !== false && (
          <>
            {/* DAMAGER NAME */}
            <Input
              inputOptions={{
                isRequired: fieldRequirements.DamagerName,
                label: localization.translate('damagerKnown.damagerNameLabel'),
                name: claimFields.damagerName,
                onChange: () => {},
                value: formContext.getValues(claimFields.damagerName),
              }}
              tooltip={localization.translate('damagerKnown.damagerNameTooltip')}
            />

            {/* DAMAGER IDENTIFIED */}
            <TextArea
              options={{
                isRequired: fieldRequirements.DamagerIdentified,
                label: localization.translate('damagerKnown.damagerIdentifiedLabel'),
                name: claimFields.damagerIdentified,
                onChange: () => {},
              }}
              tooltip={localization.translate('damagerKnown.damagerIdentifiedTooltip')}
            />
          </>
        )}

        {/* Is Damager Contact Details Known? */}
        <YesNoButton
          isRequired
          isSelected={isDamagerDetailsKnown}
          labelText={localization.translate('damagerKnown.isDamagerContactDetailsKnownLabel')}
          name={claimFields.haveDamagerContactDetails}
          onNoClick={() => {}}
          onYesClick={() => {}}
          tooltip={localization.translate('damagerKnown.isDamagerContactDetailsKnownTooltip')}
        />

        {isDamagerDetailsKnown !== false && (
          <>
            {/* CONTACT NAME */}
            <Input
              inputOptions={{
                isRequired: fieldRequirements.DamagerContactName,
                label: localization.translate('damagerKnown.damagerContactNameLabel'),
                name: claimFields.damagerContactName,
                onChange: () => {},
                value: formContext.getValues(claimFields.damagerContactName),
              }}
              tooltip={localization.translate('damagerKnown.damagerContactNameTooltip')}
            />

            {/* PHONE NUMBER */}
            <Input
              inputOptions={{
                isRequired: fieldRequirements.DamagerPhoneNumber,
                label: localization.translate('damagerKnown.damagerPhoneNumberLabel'),
                name: claimFields.damagerPhoneNumber,
                onChange: () => {},
              }}
              tooltip={localization.translate('damagerKnown.damagerPhoneNumberTooltip')}
              type={'phone'}
            />

            {/* EMAIL ADDRESS */}
            <Input
              inputOptions={{
                isRequired: fieldRequirements.DamagerEmailAddress,
                label: localization.translate('damagerKnown.damagerEmailAddressLabel'),
                name: claimFields.damagerEmailAddress,
                onChange: () => {},
                value: formContext.getValues(claimFields.damagerEmailAddress),
              }}
              tooltip={localization.translate('damagerKnown.damagerEmailAddressTooltip')}
            />

            {/* DAMAGER STATEMENT */}
            <TextArea
              options={{
                isRequired: fieldRequirements.DamagerStatement,
                label: localization.translate('damagerKnown.damagerStatementLabel'),
                name: claimFields.damagerStatement,
                onChange: () => {},
              }}
              tooltip={localization.translate('damagerKnown.damagerStatementTooltip')}
            />
          </>
        )}
      </FormFields>
    </FormSection>
  );
};